import React from 'react';
import { cn } from '../lib/utils';
interface EcosystemDiagramProps {
  className?: string;
}
export function EcosystemDiagram({
  className
}: EcosystemDiagramProps) {
  return <div className={cn('relative w-full max-w-4xl mx-auto py-24 flex items-center justify-center min-h-[600px]', className)} data-id="element-18">
      {/* Center */}
      <div className="absolute z-10 text-center" data-id="element-19">
        <h3 className="text-2xl md:text-3xl font-light tracking-widest text-coral coral-glow breathe" data-id="element-20">
          Noise Lullabies
        </h3>
      </div>

      {/* Orbiting Elements - positioned absolutely to create an organic radial layout */}
      <div className="absolute inset-0 w-full h-full font-mono text-xs md:text-sm text-muted-foreground tracking-wider" data-id="element-21">
        <div className="absolute top-[15%] left-[20%] text-right max-w-[150px] slow-pulse" style={{
        animationDelay: '0s'
      }} data-id="element-22">
          caregivers &amp; families
        </div>

        <div className="absolute top-[25%] right-[15%] max-w-[180px] slow-pulse" style={{
        animationDelay: '1s'
      }} data-id="element-23">
          ambient &amp; experimental
          <br data-id="element-24" />
          music audiences
        </div>

        <div className="absolute top-[50%] left-[5%] -translate-y-1/2 text-right max-w-[120px] slow-pulse" style={{
        animationDelay: '2s'
      }} data-id="element-25">
          listeners
        </div>

        <div className="absolute top-[50%] right-[5%] -translate-y-1/2 max-w-[180px] slow-pulse" style={{
        animationDelay: '3s'
      }} data-id="element-26">
          deep listening
          <br data-id="element-27" />
          communities
        </div>

        <div className="absolute bottom-[25%] left-[15%] text-right max-w-[180px] slow-pulse" style={{
        animationDelay: '4s'
      }} data-id="element-28">
          curators &amp;
          <br data-id="element-29" />
          festival organisers
        </div>

        <div className="absolute bottom-[20%] right-[20%] max-w-[200px] slow-pulse" style={{
        animationDelay: '5s'
      }} data-id="element-30">
          sound engineers &amp;
          <br data-id="element-31" />
          mastering collaborators
        </div>

        <div className="absolute bottom-[5%] left-1/2 -translate-x-1/2 text-center w-full max-w-[300px] slow-pulse" style={{
        animationDelay: '6s'
      }} data-id="element-32">
          cultural contributors across
          <br data-id="element-33" />
          languages &amp; geographies
        </div>

        {/* Subtle connecting dots/lines background */}
        <svg className="absolute inset-0 w-full h-full opacity-10 pointer-events-none" aria-hidden="true" data-id="element-34">
          <circle cx="50%" cy="50%" r="25%" stroke="currentColor" strokeWidth="0.5" fill="none" strokeDasharray="4 8" className="text-coral" data-id="element-35" />
          <circle cx="50%" cy="50%" r="40%" stroke="currentColor" strokeWidth="0.5" fill="none" strokeDasharray="2 12" data-id="element-36" />
        </svg>
      </div>
    </div>;
}